import { render, staticRenderFns } from "./channelLabel.vue?vue&type=template&id=d4b4a1ce&scoped=true&"
import script from "./channelLabel.vue?vue&type=script&lang=js&"
export * from "./channelLabel.vue?vue&type=script&lang=js&"
import style0 from "./channelLabel.vue?vue&type=style&index=0&id=d4b4a1ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4b4a1ce",
  null
  
)

export default component.exports